import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const ReturnInformationContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const AttachmentDisplayContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '30%',
  minWidth: '290px',
  marginRight: '15px',
  marginBottom: '15px',

  'div.title': {
    fontsize: '1.2rem'
  },

  'div.emptyFile': {
    color: v.textGray,
    fontSize: '1rem',
    fontStyle: 'italic'
  }
})
